<template>
    <div v-if="visible">
        <el-dialog :visible.sync="visible"
                    :modal-append-to-body="false"
                    @close="close"
                    custom-class="pay-dialog"
                    top="15vh"
                    width="1152px"
                    :destroy-on-close="true"
                    class="pay-dialog"
                    v-if="payvisible && memverlist.length"
                    :close-on-click-modal="false">
            <div class="head" slot="title">
                <div class="head-left">
                    开通项目
                </div>
                <!-- <div class="head-right">
                    <img src="@/assets/pay/question.png" alt="">
                    常见问题
                </div> -->
            </div>
            <div class="pay-content">
                <div class="content-left">
                    <div class="vip-tips">
                        <img src="@/assets/pay/vip-icon.png" alt="">
                        畅享特权
                    </div>
                    <div class="vip-line"></div>
                    <div class="vip-item" v-for="(item, i) in tiplist[memverlist[payactive].name]" :key="i" v-if="veractive == 0">
                        <img src="@/assets/pay/tips.png" alt="">
                        {{ item.content }}
                    </div>
                    <div class="vip-item" v-for="(item, i) in tiplist['定制']" :key="i" v-if="veractive == 1">
                        <img src="@/assets/pay/tips.png" alt="">
                        {{ item.content }}
                    </div>
                </div>
                <div class="content-center">
                    <div class="vip-center-top">
                        <img src="@/assets/pay/right-top-bg.png" alt="" class="vip-top-bg">
                        数据可视化大屏组件/模板定制
                        <el-popover
                            placement="top-start"
                            width="180"
                            trigger="hover">
                            <div class="connect-btn" slot="reference">
                                联系客服
                            </div>
                            <div class="vx-qrcode">
                                <img src="@/assets/qrcode.jpg" alt="">
                            </div>
                        </el-popover>
                    </div>
                    <div class="center-title">
                        选择版本类型
                    </div>
                    <div class="version-list">
                        <div class="version-item" v-for="item in version" :key="item.id" :class="{active: item.id == veractive}" @click="verchange(item)">
                            {{ item.name }}
                        </div>
                    </div>
                    <div class="center-title">
                        选择项目套餐
                    </div>
                    <div v-if="veractive == 0">
                        <div class="pay-list">
                            <div class="pay-item" :class="{active: i == payactive}" v-for="(item, i) in memverlist" :key="i" @click="paychange(i)">
                                <div class="pay-disc">{{ item.discount_label || '--' }}</div>
                                <div class="pay-title">{{ item.name || '--' }}</div>
                                <div class="pay-count">￥<em>{{ item.price || '--' }}</em></div>
                                <div class="pay-ori">原价{{ item.original_price || '--' }}</div>
                            </div>
                        </div>
                        <div class="pay-tips">
                            划线价格说明：商品展示的划横线价格为参考价，并非原价，该价格可能是商品在其他售卖渠道的历史售价、活动指导价、建议零售价等或其他真实有依据的价格仅供您参考
                        </div>
                    </div>
                    <div v-else>
                        <div class="pay-list">
                            <div class="pay-item" :class="{active: item.id == cusactive}" v-for="item in customlist" :key="item.id" @click="cuschange(item.id)">
                                <div class="pay-title title2">{{ item.name || '--' }}</div>
                                <div class="pay-count"><em>联络客服</em></div>
                                <div class="pay-ori2">一次部署，永久使用</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content-right" v-if="veractive == 0">
                    <div class="pay-price">￥<em>{{ memverlist[payactive] ? memverlist[payactive].price : '--' }}</em></div>
                    <div class="pay-code" v-loading="codeloading">
                        <div style="width: 152px;height: 152px;" id="qrcode"></div>
                        <!-- <img src="@/assets/nodata.png" alt="" class="pay-img"> -->
                    </div>
                    <div class="pay-text" v-if="ispay">使用微信扫码支付</div>
                    <div class="pay-text pay" v-else @click="resetcode">二维码已过期请刷新</div>
                    <div class="pay-text">支付即视为你同意<em>相关协议</em>条例</div>
                    <el-button class="public-button" size="mini" @click="openpublic">我要对公转账</el-button>
                </div>
                <div class="content-right" v-else>
                    <div class="pay-code paycode2">
                        <img src="@/assets/qrcode.jpg" alt="" class="pay-img">
                    </div>
                    <div class="pay-text" v-if="ispay">微信扫码联系客服</div>
                </div>
            </div>
        </el-dialog>
        <el-dialog :visible="showpublic"
                    :modal-append-to-body="false"
                    @close="publicclose"
                    custom-class="public-dialog"
                    width="482px"
                    top="20vh">
            <div class="public-title">对公转账</div>
            <div class="order-top">
                <img src="@/assets/icon9.png" alt="">
                下单成功
            </div>
            <div class="order-tips">
                完成转账后，请在下面填写你的公司全称
            </div>
            <div class="public-content">
                <div class="public-item" v-for="(item, i) in publiclist" :key="i">
                    <div class="public-item-title">{{ item.name }}</div>
                    <div class="public-item-value" v-if="item.key && item.key == 'price'">￥{{ memverlist[payactive] ? memverlist[payactive].price : '--' }}</div>
                    <el-input v-else-if="item && item.key == 'company'" v-model="item.value" placeholder="请输入你的公司全称" class="company-input" size="small">
                    </el-input>
                    <div class="public-item-value" v-else>{{ item.value }}</div>
                </div>
            </div>
            <el-button class="push-btn" type="primary">
                提交
            </el-button>
            <div class="copy-text">复制转账信息</div>
        </el-dialog>
    </div>
</template>

<script>
import { getMemberPrice, buildCode, getOrderStatus } from '@/api/new'
import QRCode from 'qrcodejs2';

export default {
    props: {
        payvisible: {
            type: Boolean,
            default: false
        },
        iscustom: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            visible: false,
            tiplist: {
                '月费会员': [
                    { content: '去除水印' },
                    { content: '整体项目数量10个' },
                    { content: '在线表格数据编辑' },
                    { content: '享有通用模板' },
                    { content: '支持项目分享' },
                    { content: '在线答疑' },
                ],
                '年费会员': [
                    { content: '去除水印/官方Logo' },
                    { content: '整体项目数量50个' },
                    { content: '在线表格数据编辑' },
                    { content: '支持API数据接入' },
                    { content: '享有高级模板' },
                    { content: '支持项目分享' },
                    { content: '支持组件收藏' },
                    { content: '人工客服答疑' },
                ],
                '定制': [
                    { content: '去除水印/官方Logo' },
                    { content: '整体项目数量50个' },
                    { content: '在线表格数据编辑' },
                    { content: '支持API数据接入' },
                    { content: '享有高级模板' },
                    { content: '支持项目分享' },
                    { content: '支持组件收藏' },
                    { content: '人工客服答疑' },
                ]
            },
            //     { content: '整体项目数量20个' },
            //     // { content: '生成可视化源码' },
            //     { content: '分享链接' },
            //     { content: '可用高级模板' },
            //     { content: '丰富组件替换' },
            //     { content: '更多功能解锁中...' },
            paylist: [
                { time: '1季度', disc: '7.9折', price: '99.00', oriprice: '125.00', id: 0 },
                { time: '1年', disc: '4.4折', price: '299.00', oriprice: '680.00', id: 1 },
            ],
            version: [
                { name: '企业标准版', id: 0, level: 1, children: [{ time: '1季度', disc: '7.9折', price: '99.00', oriprice: '125.00', id: 0 },{ time: '1年', disc: '4.4折', price: '299.00', oriprice: '680.00', id: 1 },] },
                { name: '私有化部署', id: 1, level: 2, children: [{ time: '1季度', disc: '7.9折', price: '99.00', oriprice: '125.00', id: 0 },{ time: '1年', disc: '4.4折', price: '299.00', oriprice: '680.00', id: 1 },] },
                // { name: '企业专业版', id: 1, level: 2, children: [{ time: '1季度', disc: '7.9折', price: '189.00', oriprice: '240.00', id: 0 },{ time: '1年', disc: '4.4折', price: '1299.00', oriprice: '2950.00', id: 1 },] }
            ],
            customlist: [
                { id: 0, name: '私有化部署' },
            ],
            cusactive: 0,
            veractive: 0,
            payactive: 1,
            memverlist: [],
            codeloading: false,
            timer: null,
            timer1: null,
            ispay: true,
            order_sn: '',
            paylevel: 0,
            showpublic: false,
            publiclist: [
                { name: '转账金额', value: '', key: 'price' },
                { name: '公司全称', value: '福州今领信息科技有限公司' },
                { name: '银行账户', value: '351008080018010045063' },
                { name: '开户银行', value: '交通银行福州交通路支行' },
                { name: '付款公司', value: '', key: 'company' },
            ]
        }
    },
    methods: {
        close() {
            clearTimeout(this.timer)
            clearInterval(this.timer1)
            this.timer = null
            this.timer1 = null
            this.$emit('payclose')
            this.visible = false
        },
        paychange(item) {
            if (item == this.payactive) return
            this.payactive = item
            this.getmempridel()
        },
        verchange(item) {
            if (item.id == this.veractive) return
            this.veractive = item.id
            if (item.id == 0) {
                this.payactive = 1
                this.getmemprice()
            } else {
                clearInterval(this.timer1)
                this.timer1 = null
            }
        },
        // 获取会员套餐列表
        getmemprice() {
            let goodstype = this.version[this.veractive].level
            const params = {
                page: 1,
                limit: 10,
            }
            getMemberPrice(params).then(res => {
                if (res.status == 200) {
                    this.memverlist = res.data
                    this.payactive = this.memverlist.length - 1
                    this.getmempridel()
                }
            })
        },
        getmempridel() {
            clearInterval(this.timer1)
            this.timer1 = null
            this.codeloading = true
            let index = this.payactive
            let vid = this.memverlist[index].id
            const params = {
                goods_id: vid
            }
            buildCode(params).then(res => {
                if (res.status == 200) {
                    if (!this.visible) return
                    this.order_sn = res.data.order_sn
                    this.setCode(res.data.code_url)
                    this.timer1 = setInterval(() => {
                        this.getPayStatus()
                    }, 5000);
                }
            })
        },
        resetcode() {
            this.getmempridel()
        },
        setCode(url) {
            this.ispay = true
            this.timer = null
            clearTimeout(this.timer)
            if (!this.visible) return
            const qrcodeDiv = document.getElementById('qrcode');
            // 清空容器内的内容
            qrcodeDiv.innerHTML = '';
            try {
                // 创建一个新的二维码实例
                this.qrCode = new QRCode(qrcodeDiv, {
                    // 二维码的内容
                    text: url,
                    // 二维码的宽度
                    width: 152,
                    // 二维码的高度
                    height: 152,
                    // 二维码的颜色
                    colorDark: '#000000',
                    // 二维码背景色
                    colorLight: '#ffffff',
                    // 二维码的容错级别
                    correctLevel: QRCode.CorrectLevel.H
                });
                this.timer = setTimeout(() => {
                    this.ispay = false
                    this.codeloading = true
                }, 300000);
                this.codeloading = false
            } catch (error) {
                this.codeloading = false
                console.error('生成二维码时出错:', error);
            }
        },
        getPayStatus() {
            let params = {
                order_sn: this.order_sn
            }
            getOrderStatus(params).then(res => {
                if(res.status == 200) {
                    this.$message.success('支付成功')
                    // let level = this.version[this.veractive].level
                    // let userInfor = JSON.parse(localStorage.getItem('userInfor'))
                    // if (level > userInfor.role_id) {
                    //     userInfor.role_id = level
                    //     localStorage.setItem('userInfor', JSON.stringify(userInfor))
                    // }
                    this.close()
                    this.$emit('updatainfo')
					// window.location.reload();
                }
            })
        },
        cuschange(id) {
            if(id == this.cusactive) {
                return
            }
            this.cusactive = id
        },
        publicclose() {
            this.showpublic = false
        },
        openpublic() {
            this.showpublic = true
        }
    },
    mounted() {
        if (this.payvisible) {
            this.getmemprice()
        }
        if (this.iscustom) {
            this.verchange(this.version[1])
        }
    },
    beforeDestroy() {
    },
    watch: {
        payvisible(n) {
            this.visible = n
            if (this.memverlist && this.memverlist.length) {
                this.getmempridel()
                return
            }  else if (this.visible) {
                this.getmemprice()
            }
        },
        iscustom (n) {
            if(n && this.veractive == 0) {
                this.verchange(this.version[1])
            } else if (!n && this.veractive == 1) {
                this.verchange(this.version[0])
            }
        }
    }
}
</script>

<style lang="scss">

.vx-qrcode {
    width: 180px;
    height: 180px;
    display: block;
    margin: auto;
    img {
        width: 100%;
        height: 100%;
    }
}
.pay-dialog.el-dialog {
    border-radius: 20px;
    .el-dialog__close {
        font-size: 24px;
    }
    .el-dialog__header {
        padding: 0;
        width: 100%;
        height: 131px;
        background: url(@/assets/pay/head-bg.png) no-repeat;
        background-size: calc(100% + 1px) 100%;
        border-radius: 20px 20px 0 0;
    }
    .head {
        display: flex;
        align-items: center;
        padding: 32px 100px 0 36px;
        .head-left {
            font-family: PangMenZhengDao;
            font-weight: 400;
            font-size: 23px;
            color: #FEFFFE;
            line-height: 100%;
        }
        .head-right {
            margin-left: auto;
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 12px;
            color: #E1ECF4;
            line-height: 100%;
            display: flex;
            align-items: center;
            img {
                width: 12px;
                height: 12px;
                margin-right: 10px;
            }
        }
    }
    .el-dialog__body {
        padding: 0;
        margin-top: -52px;
        height: 566px;
        border-radius: 20px;
        overflow: hidden;
        background: #fff;
        z-index: 1;
        position: relative;
        .content-left {
            width: 224px;
            height: 100%;
            background: url(@/assets/pay/left-bg.png) no-repeat;
            background-size: 100% 100%;
        }
    }
    .pay-content {
        display: flex;
        height: 100%;
    }
    .vip-tips {
        display: inline-flex;
        width: 100%;
        align-items: center;
        justify-content: center;
        margin-top: 40px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 23px;
        color: #6A2E12;
        line-height: 26px;
        img {
            width: 26px;
            height: 25px;
            margin-right: 12px;
        }
    }
    .vip-line {
        width: 20px;
        height: 4px;
        background: #772D0F;
        margin: 28px auto 32px;
    }
    .vip-item {
        margin-left: 32px;
        display: flex;
        align-items: center;
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 16px;
        color: #772D0F;
        img {
            width: 17px;
            height: 17px;
            margin-right: 12px;
        }
        & + .vip-item {
            margin-top: 24px;
        }
    }
    .content-center {
        margin-left: 28px;
        padding-right: 28px;
        border-right: 1px solid #F2F3F5;
        max-width: 611px;
    }
    .vip-center-top {
        display: flex;
        align-items: center;
        width: 582px;
        height: 48px;
        padding: 24px;
        box-sizing: border-box;
        background: #FF5A49;
        border-radius: 9px;
        margin-top: 26px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #FFEAD7;
        position: relative;
        .vip-top-bg {
            position: absolute;
            left: 0;
            top: 0;
            width: 218px;
            height: 48px;
        }
        .connect-btn {
            padding: 6px 12px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            font-size: 12px;
            line-height: 12px;
            color: #A11B01;
            background: linear-gradient(90deg, #FFCE95, #FFE6D3);
            border-radius: 11px;
            cursor: pointer;
            position: absolute;
            right: 24px;
            top: calc(50% - 12px);
        }
    }
    .center-title {
        font-family: Source Han Sans CN;
        font-weight: bold;
        font-size: 19px;
        color: #191A22;
        line-height: 100%;
        position: relative;
        width: fit-content;
        margin-top: 28px;
        &::after {
            content: "";
            position: absolute;
            width: calc(100% - 8px);
            height: 8px;
            left: 4px;
            bottom: -4px;
            background: linear-gradient(to right, #FAE9CF, rgba(250, 233, 207, 0));
            z-index: -1;
        }
    }
    .pay-list {
        display: flex;
        align-items: center;
        margin-top: 24px;
        column-gap: 12px;
        .pay-item {
            width: 180px;
            height: 127px;
            background: #F9F9FA;
            border-radius: 10px;
            overflow: hidden;
            position: relative;
            cursor: pointer;
            border: 1px solid transparent;
            transition: all 0.3s linear;
            &.active {
                border: 1px solid #E7AE75;
                background: #FFF7F1;
            }
            .cus-title {
                margin: auto 0 auto 16px;
                font-size: 24px;
                padding-top: 44px;
            }
        }
        .pay-disc {
            padding: 4px 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 15px;
            background: linear-gradient(90deg, #F17C42, #E9432A);
            border-radius: 0px 9px 0px 9px;
            position: absolute;
            right: 0;
            top: 0;
        }
        .pay-title {
            font-family: Source Han Sans CN;
            font-weight: bold;
            font-size: 19px;
            color: #343639;
            line-height: 19px;
            margin: 20px 0 0 18px;
            &.title2 {
                & + .pay-count {
                    em {
                        margin-left: 0;
                    }
                }
            }
        }
        .pay-count {
            font-family: Source Han Sans CN;
            font-weight: 500;
            font-size: 16px;
            color: #D74949;
            line-height: 16px;
            margin: 16px 0 0 18px;
            em {
                margin-left: 6px;
                font-weight: bold;
                font-size: 24px;
                line-height: 24px;
            }
        }
        .pay-ori {
            margin: 16px 0 0 18px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            font-size: 14px;
            color: #93979B;
            line-height: 15px;
            text-decoration-line: line-through;
        }
        .pay-ori2 {
            margin: 16px 0 0 18px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            font-size: 14px;
            color: #93979B;
            line-height: 15px;
        }
    }
    .pay-tips {
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 13px;
        color: #B4B6BB;
        line-height: 26px;
        max-width: 582px;
        margin-top: 36px;
    }
    .content-right {
        flex: 1;
    }
    .pay-price {
        margin: 62px auto 32px;
        text-align: center;
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 16px;
        color: #D64949;
        em {
            font-size: 35px;
            margin-left: 12px;
        }
    }
    .pay-code {
        padding: 16px;
        border-radius: 8px;
        border: 1px solid #E9E8Ed;
        width: fit-content;
        margin: 0 auto;
        &.paycode2 {
            margin-top: 148.5px;
        }
        .pay-img {
            width: 152px;
            height: 152px;
        }
    }
    .pay-text {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 12px;
        color: #7F8791;
        line-height: 12px;
        margin-top: 20px;
        text-align: center;
        em {
            color: #2254F5;
            margin: 0 4px;
        }
        & + .pay-text {
            margin-top: 16px;
        }
        &.pay {
            color: #2254F5;
            cursor: pointer;
        }
    }
    .public-button {
        padding: 10px 78px;
        font-size: 13px;
        margin: 85px auto 0;
        display: block;
    }
    .version-list {
        display: flex;
        align-items: center;
        column-gap: 12px;
        margin-top: 22px;
    }
    .version-item {
        width: 283px;
        height: 42px;
        background: #F9F9FA;
        border-radius: 7px;
        border: 1px solid transparent;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 16px;
        color: #343639;
        line-height: 16px;
        transition: all 0.3s linear;
        cursor: pointer;
        &.active {
            background: #FFF7F1;
            border: 1px solid #E7AE75;
        }
    }
}
.public-dialog {
    &.el-dialog {
        background: #FFFFFF;
        border-radius: 14px;
        overflow: hidden;
    }
    .el-dialog__header {
        padding: 0;
    }
    .el-dialog__close {
        font-size: 24px;
    }
    .public-title {
        font-family: Source Han Sans CN;
        font-weight: bold;
        font-size: 18px;
        color: #24282C;
        line-height: 23px;
    }
    .order-top {
        display: flex;
        align-items: center;
        margin-top: 36px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 16px;
        color: #24282C;
        line-height: 16px;
        img {
            width: 27px;
            height: 27px;
            margin-right: 24px;
        }
    }
    .order-tips {
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 14px;
        color: #7F8892;
        line-height: 14px;
        margin-top: 18px;
    }
    .public-content {
        box-sizing: border-box;
        padding: 38px 46px;
        border-radius: 8px;
        border: 1px solid #E8EBED;
        margin-top: 20px;
        .public-item {
            display: flex;
            align-items: center;
            & + .public-item {
                margin-top: 26px;
            }
        }
        .public-item-title {
            font-family: Source Han Sans CN;
            font-weight: bold;
            font-size: 14px;
            color: #222529;
            line-height: 14px;
            margin-right: 12px;
        }
        .public-item-value {
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #222529;
            line-height: 14px;
        }
        .company-input {
            width: 231px;
            .el-input__inner {
                border: 0px;
                border-bottom: 1px solid #E8EBED;
            }
        }
    }
    .push-btn {
        margin-top: 20px;
        width: 100%;
    }
    .copy-text {
        text-align: center;
        margin-top: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #0089FF;
        line-height: 14px;
        cursor: pointer;
    }
}
</style>